module.exports = __webpack_public_path__ + "img/flechaAtras.2a3009db.svg";